// Availability extension (admin side): what is left to sell.
// The tab is the old catalog editor's AvailabilityTab, reused as it is — it reads and
// writes through the shared catalog editor (../shared/catalog-editor.jsx).
import { ArchiveBoxIcon } from "@heroicons/react/24/outline"
import AvailabilityTab from "./AvailabilityTab"
import { CatalogEditorProvider, catalogSection, catalogVisible, useCatalogVisibilityContext } from "../shared/catalog-editor"

export const StoreProductExtension = {
  // the framework's own Availability tab is the same subject — whether the
  // product may be bought and how that is decided — so it is rendered here
  // instead of standing as a second tab of the same name
  absorbs: ["availability"],
  id: "inventory",
  label: "Availability",
  description: "Availability for purchase and the stock or free license key count",
  section: {
    component: catalogSection(AvailabilityTab),
    label: "Availability",
    icon: ArchiveBoxIcon,
    order: 500,
    visible: catalogVisible("availability"),
  },
  provider: CatalogEditorProvider,
  visibilityContext: useCatalogVisibilityContext,
}
